import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { succesMessage } from "../../../../../../helpers/AssetsHelpers";
import {
  ajouterStrategieOrganisation,
  getStrategieGlobaleMission,
} from "../../../../../../data/stategieGlobale";
import { Button, Input, Tooltip, Typography } from "antd";
import { appTheme } from "../../../../../../config/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport, faSave } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

const { Title } = Typography;

const OrganisationPolitique = ({
  mission,
  strategies,
  isProvisoire,
  codeSommaire,
  heureEntree,
  date,
  tache_id,
  intervention_id,
  exercicePrecedentData,
  fetchStrategieGlobale,
}) => {
  const [organisation, setOrganisation] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (strategies) {
      setOrganisation(strategies.organisation);
    } else {
      setOrganisation("");
    }
  }, [strategies]);

  const onChange = (e) => {
    setOrganisation(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      organisation,
      isProvisoire: parseInt(isProvisoire) === 1,
      exercice_id: mission.id,
      client_id: mission.client_id,
      codeSommaire,
      heureEntree,
      date,
      tache_id,
      intervention_id,
    };

    const { status, message } = await ajouterStrategieOrganisation(data);
    if (status === "success") {
      setLoading(false);
      await swal(succesMessage, "", "success");
      fetchStrategieGlobale();
    } else {
      setLoading(false);
      await swal(message, "", "error");
    }
  };

  const handleImport = async () => {
    const result = await Swal.fire({
      title: '<strong style="font-size: 1.5em;">Êtes vous sûr ?</strong>',
      html: "Voulez-vous importer les données de l'exercice précédent ? Les données actuelles seront remplacées.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d1ec51",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Annuler",
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    try {
      const res = await getStrategieGlobaleMission(exercicePrecedentData.id);
      const strategie = (res.result || []).find(
        (item) => item.isProvisoire === (parseInt(isProvisoire) === 1)
      );

      if (strategie) {
        setOrganisation(strategie.organisation);
        await swal({
          title: "Importation effectuée avec succès",
          text: "Pensez à enregistrer les modifications.",
          icon: "success",
        });
      } else {
        setOrganisation("");
        await swal(
          "Aucune stratégie trouvée pour cet exercice précédent.",
          "",
          "error"
        );
      }
    } catch (error) {
      await swal("Erreur lors de l'importation", "", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column fv-plugins-bootstrap5 fv-plugins-framework pb-10">
      {
        <div className="d-flex justify-content-end align-items-end mb-10 gap-2">
          {exercicePrecedentData && !organisation && (
            <Tooltip title="Importer les données de l'année précédente">
              <Button
                disabled={
                  mission.isCloture === 1 || mission.isClotureProvisoire === 1
                }
                loading={loading}
                size={"large"}
                style={{
                  backgroundColor: appTheme.colors.primary,
                  color: "white",
                }}
                icon={
                  <FontAwesomeIcon
                    style={{ paddingRight: "10" }}
                    icon={faFileImport}
                  />
                }
                onClick={handleImport}
              >
                {!loading && (
                  <span className="indicator-label text-white">Importer</span>
                )}
                {loading && (
                  <span className="indicator-progress  text-white">
                    Importation en cours...
                  </span>
                )}
              </Button>
            </Tooltip>
          )}
          <Tooltip title="Enregistrer">
            <Button
              disabled={
                mission.isCloture === 1 || mission.isClotureProvisoire === 1
              }
              size={"large"}
              loading={loading}
              style={{
                backgroundColor: appTheme.colors.secondary,
                color: "white",
              }}
              icon={
                <FontAwesomeIcon style={{ paddingRight: "10" }} icon={faSave} />
              }
              onClick={handleSubmit}
            >
              {!loading && (
                <span className="indicator-label text-white">Enregistrer</span>
              )}
              {loading && (
                <span className="indicator-progress text-white">
                  Patientez svp...
                </span>
              )}
            </Button>
          </Tooltip>
        </div>
      }
      <div className="card-header">
        <div className="card-title">
          <Title
            style={{
              display: "block",
              fontWeight: "600",
              color: appTheme.colors.primary,
              // textAlign: "center"
            }}
            level={4}
          >
            {
              "EC4.4: Organisation, politique comptable et référentiel comptable"
            }
          </Title>
        </div>
      </div>
      <div className="mt-10"></div>
      <Input.TextArea
        size="large"
        placeholder="Saissiser l'organisation, politique comptable"
        readOnly={mission.isCloture === 1 || mission.isClotureProvisoire === 1}
        maxLength={5000}
        showCount
        autoSize={{
          minRows: 8,
          maxRows: 25,
        }}
        onChange={onChange}
        value={organisation}
      />
    </div>
  );
};

export default OrganisationPolitique;
